import { Box, styled } from "@mui/material"

export const BasicHeaderWrapper = styled(Box)(({ width }: any) => ({
  // border: "1px solid red",
  width: width || "auto",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "0",
}))
